package com.essntl.features.address.domain.model

data class AddressModel(
    val id: String,
    val line1: String?,
    val line2: String?,
    val city: String?,
    val state: String?,
    val zipCode: String?,
    val country: String?,
    val description: String?,
    val latitude: Double?,
    val longitude: Double?,
    val createdAt: String,
    val updatedAt: String,
) {
    fun getChangedFields(address: AddressModel) =
        AddressModel(
            id = id,
            createdAt = createdAt,
            updatedAt = updatedAt,
            line1 = if (line1 != address.line1) address.line1 else "",
            city = if (city != address.city) address.city else "",
            country = if (country != address.country) address.country else "",
            description = if (description != address.description) address.description else null,
            line2 = if (line2.orEmpty() != address.line2.orEmpty()) address.line2 else null,
            state = if (state.orEmpty() != address.state.orEmpty()) address.state else null,
            zipCode = if (zipCode.orEmpty() != address.zipCode.orEmpty()) address.zipCode else null,
            latitude = null,
            longitude = null,
        )

    val isEmpty
        get() = this.copy(id = "", createdAt = "", updatedAt = "") == empty

    companion object {
        val empty =
            AddressModel(
                id = "",
                line1 = "",
                city = "",
                country = "",
                createdAt = "",
                updatedAt = "",
                line2 = null,
                state = null,
                zipCode = null,
                latitude = null,
                longitude = null,
                description = null,
            )
    }
}